import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

export const postSendEmailContactUs = async <T>(
  subject: string,
  message: string,
): Promise<T> => {
  return (
    await axios.post(`${API_URL}send-email/contact-us`, { subject, message })
  ).data;
};

export const postSendEmailNotify = async <T>(
  subject: string,
  message: string,
): Promise<T> => {
  return (await axios.post(`${API_URL}send-email/notify`, { subject, message }))
    .data;
};
